import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

import { buildAvailabilityQueryOptions } from '@/components/integration/nylas/scheduler/helpers'
import {
  AvailabilityFilter,
  EVERY_ADVISER_AVAILABILITY_FILTER,
  SchedulerAvailabilitySource,
  SchedulerOwningEntityType,
} from '@/components/integration/nylas/scheduler/types'

export default function useAvailabilityPrefetch(
  type: SchedulerOwningEntityType,
  owningEntityId: number | string,
  availabilityFilter: AvailabilityFilter = EVERY_ADVISER_AVAILABILITY_FILTER,
  availabilitySource?: SchedulerAvailabilitySource,
) {
  const queryClient = useQueryClient()
  const { locationId, inPersonFormat } = availabilityFilter

  return useCallback(
    (start: Date, end: Date) =>
      queryClient.prefetchQuery({
        ...buildAvailabilityQueryOptions(
          type,
          owningEntityId,
          start,
          end,
          { locationId, inPersonFormat },
          availabilitySource,
        ),
      }),
    [
      queryClient,
      type,
      owningEntityId,
      locationId,
      inPersonFormat,
      availabilitySource,
    ],
  )
}
